import React, { useMemo, useState } from 'react';
import { Col, Form, Row } from 'react-bootstrap';

import { usePokCore } from '../../../common/hooks/usePokCore';
import { useNotifications } from '../../../common/hooks/useNotifications';
import { useTranslation } from '../../../common/hooks/useTranslation';
import FormRow from '../../../app/components/FormRow';

interface NoOrderRequiredTabProps {
  estimateItemId?: string;
  onNoOrderRequiredChange?: (value: boolean) => void;
}

export const NoOrderRequiredTab: React.FC<NoOrderRequiredTabProps> = props => {
  const [noOrderRequired, setNoOrderRequired] = useState<boolean | undefined>(
    undefined,
  );

  const pok = usePokCore();
  const notifications = useNotifications();
  const { t, tk } = useTranslation('projectLng');

  useMemo(() => {
    if (props.estimateItemId) {
      pok.stepDefinitions
        .getNoOrderRequired(props.estimateItemId)
        .then(result => {
          if (result) {
            setNoOrderRequired(result.toString() === 'true');
          }
        })
        .catch(error => {
          notifications.caughtError(error);
        });
    }
  }, [notifications, pok.stepDefinitions, props.estimateItemId]);

  return (
    <Row>
      <Col className="col-lg-6 col-12 mb-1">
        <FormRow
          controlId="noOrderRequired"
          label={t(tk.estimates.noOrderRequired)}
          className="mt-3"
        >
          <Form.Check
            type="checkbox"
            className="pt-2"
            checked={noOrderRequired || false}
            onChange={e => {
              setNoOrderRequired(e.target.checked);
              props.onNoOrderRequiredChange?.(e.target.checked);
            }}
          />
        </FormRow>
      </Col>
    </Row>
  );
};
